import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { deleteFeedback } from '../../../redux';
import TextField from 'material-ui/TextField';
import './index.css';

function FeedbackTile (props) {
    const {
        thisResponse,
        deleteFeedback,
        feedback,
    } = props;

    const [response, setResponse] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setResponse(thisResponse.response);
    }, []);

    const handleOpenClick = () => {
        setIsOpen(!isOpen);
    }

    const handleChange = (e) => {
        setResponse(e.target.value);
    }

    const handleDelete = () => {
        deleteFeedback(thisResponse._id, feedback)
    }

    return (
        <div className="feedbackTile">
            <h1>{thisResponse.subject}</h1>
            <h3>{thisResponse.email}</h3>
            <h4>{thisResponse.text}</h4>
            {
                isOpen ?
                    <div>
                        <TextField
                            hintText="Response"
                            fullWidth={true}
                            name="response"
                            value={response}
                            onChange={handleChange}
                            multiLine={true}
                            rows={1}
                            className="response"
                        />
                        <div className="buttons">
                            <a href={`mailto:${thisResponse.email}?subject=Re: ${thisResponse.subject}&body=${response}`}>
                                <button className="good">Send</button>
                            </a>
                            <button className="improve" onClick={handleDelete}>Delete</button>
                        </div>
                    </div>
                    :
                    <div className="buttons">
                        <button className="good" onClick={handleOpenClick}>Respond</button>
                        <button className="improve" onClick={handleDelete}>Delete</button>
                    </div>
            }
        </div>
    )
}

export default connect(state => state.root, { deleteFeedback })(FeedbackTile);
